videojs.addLanguage('oc', {
  "Audio Player": "Lector àudio",
  "Video Player": "Lector vidèo",
  "Play": "Lectura",
  "Pause": "Pausa",
  "Replay": "Tornar legir",
  "Current Time": "Durada passada",
  "Duration": "Durada",
  "Remaining Time": "Temps restant",
  "Stream Type": "Tipe de difusion",
  "LIVE": "DIRÈCTE",
  "Seek to live, currently behind live": "Trapar lo dirècte, actualament darrièr lo dirècte",
  "Seek to live, currently playing live": "Trapar lo dirècte, actualament lo dirècte es en lectura",
  "Loaded": "Cargat",
  "Progress": "Progression",
  "Progress Bar": "Barra de progression",
  "progress bar timing: currentTime={1} duration={2}": "{1} sus {2}",
  "Fullscreen": "Ecran complèt",
  "Non-Fullscreen": "Pas en ecran complèt",
  "Mute": "Copar lo son",
  "Unmute": "Restablir lo son",
  "Playback Rate": "Velocitat de lectura",
  "Subtitles": "Sostítols",
  "subtitles off": "Sostítols desactivats",
  "Captions": "Legendas",
  "captions off": "Legendas desactivadas",
  "Chapters": "Capítols",
  "Descriptions": "Descripcions",
  "descriptions off": "descripcions desactivadas",
  "Audio Track": "Pista àudio",
  "Volume Level": "Nivèl del volum",
  "You aborted the media playback": "Avètz copat la lectura del mèdia.",
  "A network error caused the media download to fail part-way.": "Una error de ret a provocat un fracàs del telecargament.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Lo mèdia a pas pogut èsser cargat, siá perque lo servidor o lo ret a fracassat siá perque lo format es pas compatible.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La lectura del mèdia es copada a causa d’un problèma de corrupcion o perque lo mèdia utiliza de foncionalitats pas suportadas pel navigador.",
  "No compatible source was found for this media.": "Cap de font compatiblas pas trobada per aqueste mèdia.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Lo mèdia es chifrat e avèm pas las claus per lo deschifrar.",
  "Play Video": "Legir la vidèo",
  "Close": "Tampar",
  "Close Modal Dialog": "Tampar la fenèstra",
  "Modal Window": "Fenèstra",
  "This is a modal window": "Aquò es una fenèstra",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Aquesta fenèstra pòt èsser tampada en quichar Escapar sul clavièr o en activar lo boton de tampadura.",
  ", opens captions settings dialog": ", dobrís la fenèstra de paramètres de legendas",
  ", opens subtitles settings dialog": ", dobrís la fenèstra de paramètres de sostítols",
  ", opens descriptions settings dialog": ", dobrís la fenèstra de paramètres de descripcions",
  ", selected": ", seleccionat",
  "captions settings": "paramètres de legendas",
  "subtitles settings": "paramètres de sostítols",
  "descriptions settings": "paramètres de descripcions",
  "Text": "Tèxte",
  "White": "Blanc",
  "Black": "Negre",
  "Red": "Roge",
  "Green": "Verd",
  "Blue": "Blau",
  "Yellow": "Jaune",
  "Magenta": "Magenta",
  "Cyan": "Cian",
  "Background": "Rèireplan",
  "Window": "Fenèstra",
  "Transparent": "Transparent",
  "Semi-Transparent": "Semitransparent",
  "Opaque": "Opac",
  "Font Size": "Talha de la polissa",
  "Text Edge Style": "Estil dels contorns del tèxte",
  "None": "Cap",
  "Raised": "Naut",
  "Depressed": "Enfonsat",
  "Uniform": "Unifòrme",
  "Dropshadow": "Ombrat",
  "Font Family": "Familha de polissa",
  "Proportional Sans-Serif": "Sans-Serif proporcionala",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Serif": "Serif proporcionala",
  "Monospace Serif": "Serif proporcionala",
  "Casual": "Manuscrita",
  "Script": "Script",
  "Small Caps": "Pichonas majusculas",
  "Reset": "Reïnicializar",
  "restore all settings to the default values": "O restablir tot a las valors per defaut",
  "Done": "Acabat",
  "Caption Settings Dialog": "Fenèstra de paramètres de legenda",
  "Beginning of dialog window. Escape will cancel and close the window.": "Debuta de la fenèstra. Escapar anullarà e tamparà la fenèstra",
  "End of dialog window.": "Fin de la fenèstra.",
  "{1} is loading.": "{1} es a cargar."
});